module.exports = __webpack_public_path__ + "img/cat-06.05375334.png";